import React, { useState } from 'react';
import '../styles/Career.css';
import CareerForm from './CareerForm';

const Career = () => {
  const [selectedPosition, setSelectedPosition] = useState('');

  const positions = [
    {
      title: 'Professional Cleaner',
      location: 'Multiple Locations',
      type: 'Full-time',
      salary: '$15-$20/hr',
      description: 'We\'re looking for dedicated cleaning professionals to join our growing team. As a Professional Cleaner, you\'ll be responsible for maintaining high cleanliness standards in residential and commercial properties.',
      responsibilities: [
        'Perform thorough cleaning of assigned areas',
        'Follow established cleaning protocols and safety guidelines',
        'Properly handle and maintain cleaning equipment',
        'Respond to client requests and feedback professionally',
        'Report maintenance issues to supervisors'
      ],
      benefits: [
        'Competitive pay with performance bonuses',
        'Flexible scheduling options',
        'Health insurance for full-time employees',
        'Paid time off and holiday pay',
        'Career advancement opportunities'
      ]
    },
    {
      title: 'Team Lead',
      location: 'Main Office',
      type: 'Full-time',
      salary: '$22-$28/hr',
      description: 'We\'re seeking experienced cleaning professionals to lead our service teams. As a Team Lead, you\'ll coordinate cleaning operations, mentor staff, and ensure client satisfaction.',
      responsibilities: [
        'Coordinate team activities and assign tasks',
        'Train and mentor new cleaning staff',
        'Perform quality inspections and address issues',
        'Manage inventory and supply requests',
        'Serve as primary point of contact for clients'
      ],
      benefits: [
        'Competitive pay with performance bonuses',
        'Comprehensive benefits package',
        'Advancement opportunities',
        'Company vehicle for work use',
        'Paid training and certification programs'
      ]
    }
  ];

  const qualifications = {
    essential: [
      'Legal authorization to work in Canada',
      'Ability to stand, walk, and perform physical tasks for extended periods',
      'Reliable transportation to and from job sites',
      'Ability to pass a background check',
      'Strong attention to detail'
    ],
    preferred: [
      'Previous cleaning experience (professional or personal)',
      'Knowledge of cleaning chemicals and equipment',
      'Customer service experience',
      'Bilingual abilities (English/Spanish)',
      'Flexible availability including weekends'
    ]
  };

  const scrollToForm = (position) => {
    setSelectedPosition(position);
    document.querySelector('.application-form').scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  return (
    <div className="career-page">
      <section className="career-hero">
        <div className="career-hero-content">
          <h1>Join Our Cleaning Team</h1>
          <p>Build a rewarding career with one of the city's most trusted cleaning services.</p>
          <button className="apply-button" onClick={() => scrollToForm('')}>Apply Now</button>
        </div>
      </section>

      <section className="available-positions">
        <h2>Available Positions</h2>
        <div className="positions-grid">
          {positions.map((position, index) => (
            <div key={index} className="position-card">
              <div className="position-header">
                <h3>{position.title}</h3>
                <div className="position-meta">
                  <span>{position.location}</span>
                  <span>{position.type}</span>
                  <span>{position.salary}</span>
                </div>
              </div>
              
              <p className="position-description">{position.description}</p>
              
              <div className="position-details">
                <div className="responsibilities">
                  <h4>Key Responsibilities:</h4>
                  <ul>
                    {position.responsibilities.map((resp, idx) => (
                      <li key={idx}>{resp}</li>
                    ))}
                  </ul>
                </div>
                
                <div className="benefits">
                  <h4>Benefits:</h4>
                  <ul>
                    {position.benefits.map((benefit, idx) => (
                      <li key={idx}>{benefit}</li>
                    ))}
                  </ul>
                </div>
              </div>
              
              <button className="apply-button" onClick={() => scrollToForm(position.title)}>
                Apply for this position
              </button>
            </div>
          ))}
        </div>
      </section>

      <section className="qualifications">
        <h2>Required Qualifications</h2>
        <p>At CleanPro Services, we look for team members who are detail-oriented, reliable, and committed to providing exceptional service. Below are the general qualifications we require:</p>
        
        <div className="qualifications-grid">
          <div className="qualification-section">
            <h3>Essential Qualifications</h3>
            <ul>
              {qualifications.essential.map((qual, index) => (
                <li key={index}>{qual}</li>
              ))}
            </ul>
          </div>
          
          <div className="qualification-section">
            <h3>Preferred Qualifications</h3>
            <ul>
              {qualifications.preferred.map((qual, index) => (
                <li key={index}>{qual}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <CareerForm selectedPosition={selectedPosition} />
    </div>
  );
};

export default Career; 